var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEggBoxFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 112,
    viewBox: "0 0 161 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.73877 81.5088L11.7036 69.823L20.3468 69.823L16.5 82.3131L0.73877 81.5088Z",
    fill: "#FCEBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.511 81.5088L149.545 69.823H139.5V82.3131L160.511 81.5088Z",
    fill: "#FCEBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.57 5.10392C147.44 1.9738 143.278 0.25 138.852 0.25H21.2232C16.7964 0.25 12.6349 1.9738 9.50479 5.10392C6.37468 8.23403 4.65088 12.3959 4.65088 16.8223V54.9664C4.65088 59.3931 6.37468 63.5546 9.50479 66.6848C12.6349 69.8149 16.7968 71.5387 21.2232 71.5387H138.852C143.279 71.5387 147.44 69.8149 150.57 66.6848C153.7 63.5546 155.424 59.3928 155.424 54.9664V16.8227C155.424 12.3959 153.7 8.2344 150.57 5.10392ZM44.6029 11.3593C44.6029 11.9261 44.139 12.3903 43.5718 12.3903H30.4446C29.8777 12.3903 29.4135 11.9265 29.4135 11.3593C29.4135 10.7925 29.8774 10.3283 30.4446 10.3283H43.5722C44.139 10.3283 44.6029 10.7925 44.6029 11.3593ZM131.836 11.3593C131.836 11.9261 131.372 12.3903 130.805 12.3903H117.678C117.111 12.3903 116.647 11.9265 116.647 11.3593C116.647 10.7925 117.11 10.3283 117.678 10.3283H130.805C131.372 10.3283 131.836 10.7925 131.836 11.3593Z",
    fill: "url(#paint0_linear_10258_11878)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.025 6.64965C146.308 3.93225 142.695 2.43591 138.852 2.43591H21.2234C17.3805 2.43591 13.7677 3.93225 11.0507 6.64965C8.33325 9.36706 6.83691 12.9799 6.83691 16.8224V54.9665C6.83691 58.8094 8.33325 62.4222 11.0507 65.1393C13.7681 67.8567 17.3809 69.353 21.2234 69.353H138.852C142.695 69.353 146.308 67.8567 149.025 65.1393C151.742 62.4219 153.239 58.809 153.239 54.9665V16.8228C153.239 12.9799 151.742 9.36706 149.025 6.64965ZM44.6031 11.3595C44.6031 11.9263 44.1393 12.3905 43.5721 12.3905H30.4448C29.878 12.3905 29.4138 11.9266 29.4138 11.3595C29.4138 10.7926 29.8776 10.3284 30.4448 10.3284H43.5725C44.1393 10.3284 44.6031 10.7926 44.6031 11.3595ZM131.837 11.3595C131.837 11.9263 131.373 12.3905 130.805 12.3905H117.678C117.111 12.3905 116.647 11.9266 116.647 11.3595C116.647 10.7926 117.111 10.3284 117.678 10.3284H130.805C131.373 10.3284 131.837 10.7926 131.837 11.3595Z",
    fill: "url(#paint1_linear_10258_11878)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.715 12.9594C141.668 11.9125 140.332 11.3594 138.852 11.3594H131.836C131.836 11.9262 131.372 12.3904 130.805 12.3904H117.677C117.11 12.3904 116.646 11.9266 116.646 11.3594H44.6029C44.6029 11.9262 44.1391 12.3904 43.5719 12.3904H30.4446C29.8778 12.3904 29.4136 11.9266 29.4136 11.3594H21.2232C19.7428 11.3594 18.4069 11.9129 17.3603 12.9594C16.3134 14.0064 15.7603 15.3419 15.7603 16.8227V54.9668C15.7603 56.4472 16.3137 57.7831 17.3603 58.8301C18.4073 59.877 19.7428 60.4302 21.2232 60.4302H138.852C140.332 60.4302 141.668 59.8767 142.715 58.8301C143.762 57.7831 144.315 56.4472 144.315 54.9668V16.8227C144.315 15.3423 143.762 14.0064 142.715 12.9594Z",
    fill: "#E9D9C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M29.9133 83.7007C37.7495 83.7007 44.102 75.2569 44.102 64.8408C44.102 54.4247 37.7495 45.9808 29.9133 45.9808C22.0771 45.9808 15.7246 54.4247 15.7246 64.8408C15.7246 75.2569 22.0771 83.7007 29.9133 83.7007Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M64.3244 83.7007C72.1606 83.7007 78.5131 75.2569 78.5131 64.8408C78.5131 54.4247 72.1606 45.9808 64.3244 45.9808C56.4882 45.9808 50.1357 54.4247 50.1357 64.8408C50.1357 75.2569 56.4882 83.7007 64.3244 83.7007Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M98.7361 83.7007C106.572 83.7007 112.925 75.2569 112.925 64.8408C112.925 54.4247 106.572 45.9808 98.7361 45.9808C90.8999 45.9808 84.5474 54.4247 84.5474 64.8408C84.5474 75.2569 90.8999 83.7007 98.7361 83.7007Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M133.148 83.7007C140.984 83.7007 147.336 75.2569 147.336 64.8408C147.336 54.4247 140.984 45.9808 133.148 45.9808C125.311 45.9808 118.959 54.4247 118.959 64.8408C118.959 75.2569 125.311 83.7007 133.148 83.7007Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 79.6349C17.5182 91.4945 24.0381 101.099 32.0781 101.099C40.1181 101.099 46.638 91.4945 46.6595 79.6349H17.4967Z",
    fill: "#AA9D93"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.379 97.366V102.032C24.379 102.683 27.8259 103.211 32.0782 103.211C36.3304 103.211 39.7773 102.683 39.7773 102.032V97.366H24.379Z",
    fill: "#AA9D93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8615 79.635C49.8829 91.4945 56.4029 101.099 64.4428 101.099C72.4828 101.099 79.0027 91.4945 79.0242 79.635H49.8615Z",
    fill: "#AA9D93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7438 97.366V102.032C56.7438 102.683 60.1906 103.211 64.4429 103.211C68.6948 103.211 72.142 102.683 72.142 102.032V97.366H56.7438Z",
    fill: "#AA9D93"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2257 79.635C82.2472 91.4945 88.7671 101.099 96.8071 101.099C104.847 101.099 111.367 91.4945 111.388 79.635H82.2257Z",
    fill: "#AA9D93"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.108 97.366V102.032C89.108 102.683 92.5549 103.211 96.8072 103.211C101.059 103.211 104.506 102.683 104.506 102.032V97.366H89.108Z",
    fill: "#AA9D93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.591 79.635C114.612 91.4945 121.132 101.099 129.172 101.099C137.212 101.099 143.732 91.4945 143.753 79.635H114.591Z",
    fill: "#AA9D93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.473 97.366V102.032C121.473 102.683 124.92 103.211 129.172 103.211C133.424 103.211 136.871 102.683 136.871 102.032V97.366H121.473Z",
    fill: "#AA9D93"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1276 48C39.9367 47.9761 46.7572 65.5796 44.0652 76.7367C41.6836 86.6162 34.8427 88.6625 29.3665 88.6625C23.8903 88.6625 17.2404 86.0047 14.6677 77.1193C11.6925 66.8299 19.0419 48.0239 29.1276 48Z",
    fill: "#ED9449"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8808 56.3766C19.5843 58.4502 18.2775 61.0602 17.9977 63.2362C17.4859 67.2434 20.4304 67.6943 21.4574 65.7061C22.4844 63.7179 23.5353 61.7058 25.2038 59.0378C27.5103 55.3518 31.2873 52.8819 29.4312 51.2797C27.5751 49.6775 23.6036 52.0176 20.8808 56.3766Z",
    fill: "#F2B25C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6709 62.0507C39.0515 62.0507 39.3601 61.7357 39.3601 61.347C39.3601 60.9584 39.0515 60.6433 38.6709 60.6433C38.2903 60.6433 37.9817 60.9584 37.9817 61.347C37.9817 61.7357 38.2903 62.0507 38.6709 62.0507Z",
    fill: "#D47858"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4459 78.8741C39.6029 78.4919 39.4222 78.0553 39.0423 77.8989C38.6623 77.7424 38.2271 77.9254 38.0701 78.3075C37.9131 78.6896 38.0939 79.1262 38.4738 79.2827C38.8537 79.4391 39.2889 79.2562 39.4459 78.8741Z",
    fill: "#D47858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3571 81.8685C19.5034 81.5125 19.3337 81.1053 18.9782 80.9589C18.6227 80.8125 18.2159 80.9823 18.0697 81.3383C17.9235 81.6942 18.0931 82.1015 18.4486 82.2479C18.8042 82.3943 19.2109 82.2244 19.3571 81.8685Z",
    fill: "#D47858"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2277 68.6514C41.7413 68.3849 41.9679 67.8022 41.7338 67.3499C41.4998 66.8976 40.8936 66.747 40.38 67.0135C39.8663 67.28 39.6397 67.8627 39.8738 68.315C40.1079 68.7673 40.714 68.9179 41.2277 68.6514Z",
    fill: "#D47858"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2887 77.8213C31.8023 77.5548 32.029 76.9721 31.7949 76.5198C31.5608 76.0675 30.9546 75.9169 30.441 76.1834C29.9274 76.4499 29.7008 77.0326 29.9348 77.4848C30.1689 77.9371 30.7751 78.0878 31.2887 77.8213Z",
    fill: "#D47858"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3126 82.6735C30.6921 82.1971 30.6773 81.5534 30.2795 81.2357C29.8817 80.9181 29.2516 81.0469 28.8721 81.5233C28.4926 81.9998 28.5075 82.6435 28.9052 82.9611C29.303 83.2787 29.9331 83.15 30.3126 82.6735Z",
    fill: "#D47858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2431 83.8026C26.6913 83.2978 26.6598 82.537 26.1725 82.1032C25.6853 81.6694 24.9269 81.727 24.4787 82.2317C24.0304 82.7365 24.062 83.4973 24.5492 83.9311C25.0364 84.3648 25.7948 84.3073 26.2431 83.8026Z",
    fill: "#D47858"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1276 48C73.9367 47.9761 80.7572 65.5796 78.0652 76.7367C75.6836 86.6162 68.8427 88.6625 63.3665 88.6625C57.8903 88.6625 51.2404 86.0047 48.6677 77.1193C45.6925 66.8299 53.0419 48.0239 63.1276 48Z",
    fill: "#ED9449"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8808 56.3766C53.5843 58.4502 52.2775 61.0602 51.9977 63.2362C51.4859 67.2434 54.4304 67.6943 55.4574 65.7061C56.4844 63.7179 57.5353 61.7058 59.2038 59.0378C61.5103 55.3518 65.2873 52.8819 63.4312 51.2797C61.5751 49.6775 57.6036 52.0176 54.8808 56.3766Z",
    fill: "#F2B25C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6709 62.0507C73.0515 62.0507 73.3601 61.7357 73.3601 61.347C73.3601 60.9584 73.0515 60.6433 72.6709 60.6433C72.2903 60.6433 71.9817 60.9584 71.9817 61.347C71.9817 61.7357 72.2903 62.0507 72.6709 62.0507Z",
    fill: "#D47858"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4459 78.8741C73.6029 78.4919 73.4222 78.0553 73.0423 77.8989C72.6623 77.7424 72.2271 77.9254 72.0701 78.3075C71.9131 78.6896 72.0939 79.1262 72.4738 79.2827C72.8537 79.4391 73.2889 79.2562 73.4459 78.8741Z",
    fill: "#D47858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3571 81.8685C53.5034 81.5125 53.3337 81.1053 52.9782 80.9589C52.6227 80.8125 52.2159 80.9823 52.0697 81.3383C51.9235 81.6942 52.0931 82.1015 52.4486 82.2479C52.8042 82.3943 53.2109 82.2244 53.3571 81.8685Z",
    fill: "#D47858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2277 68.6514C75.7413 68.3849 75.9679 67.8022 75.7338 67.3499C75.4998 66.8976 74.8936 66.747 74.38 67.0135C73.8663 67.28 73.6397 67.8627 73.8738 68.315C74.1079 68.7673 74.714 68.9179 75.2277 68.6514Z",
    fill: "#D47858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2887 77.8213C65.8023 77.5548 66.029 76.9721 65.7949 76.5198C65.5608 76.0675 64.9546 75.9169 64.441 76.1834C63.9274 76.4499 63.7008 77.0326 63.9348 77.4848C64.1689 77.9371 64.7751 78.0878 65.2887 77.8213Z",
    fill: "#D47858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3126 82.6735C64.6921 82.1971 64.6773 81.5534 64.2795 81.2357C63.8817 80.9181 63.2516 81.0469 62.8721 81.5233C62.4926 81.9998 62.5075 82.6435 62.9052 82.9611C63.303 83.2787 63.9331 83.15 64.3126 82.6735Z",
    fill: "#D47858"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2431 83.8026C60.6913 83.2978 60.6598 82.537 60.1725 82.1032C59.6853 81.6694 58.9269 81.727 58.4787 82.2317C58.0304 82.7365 58.062 83.4973 58.5492 83.9311C59.0364 84.3648 59.7948 84.3073 60.2431 83.8026Z",
    fill: "#D47858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1276 48C107.937 47.9761 114.757 65.5796 112.065 76.7367C109.684 86.6162 102.843 88.6625 97.3665 88.6625C91.8903 88.6625 85.2404 86.0047 82.6677 77.1193C79.6925 66.8299 87.0419 48.0239 97.1276 48Z",
    fill: "#ED9449"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8808 56.3766C87.5843 58.4502 86.2775 61.0602 85.9977 63.2362C85.4859 67.2434 88.4304 67.6943 89.4574 65.7061C90.4844 63.7179 91.5353 61.7058 93.2038 59.0378C95.5103 55.3518 99.2873 52.8819 97.4312 51.2797C95.5751 49.6775 91.6036 52.0176 88.8808 56.3766Z",
    fill: "#F2B25C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.671 62.0507C107.052 62.0507 107.36 61.7357 107.36 61.347C107.36 60.9584 107.052 60.6433 106.671 60.6433C106.29 60.6433 105.982 60.9584 105.982 61.347C105.982 61.7357 106.29 62.0507 106.671 62.0507Z",
    fill: "#D47858"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M107.446 78.8741C107.603 78.4919 107.422 78.0553 107.042 77.8989C106.662 77.7424 106.227 77.9254 106.07 78.3075C105.913 78.6896 106.094 79.1262 106.474 79.2827C106.854 79.4391 107.289 79.2562 107.446 78.8741Z",
    fill: "#D47858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3571 81.8685C87.5034 81.5125 87.3337 81.1053 86.9782 80.9589C86.6227 80.8125 86.2159 80.9823 86.0697 81.3383C85.9235 81.6942 86.0931 82.1015 86.4486 82.2479C86.8042 82.3943 87.2109 82.2244 87.3571 81.8685Z",
    fill: "#D47858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.228 68.6514C109.741 68.3849 109.968 67.8022 109.734 67.3499C109.5 66.8976 108.894 66.747 108.38 67.0135C107.866 67.28 107.64 67.8627 107.874 68.315C108.108 68.7673 108.714 68.9179 109.228 68.6514Z",
    fill: "#D47858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2887 77.8213C99.8023 77.5548 100.029 76.9721 99.7949 76.5198C99.5608 76.0675 98.9546 75.9169 98.441 76.1834C97.9274 76.4499 97.7008 77.0326 97.9348 77.4848C98.1689 77.9371 98.7751 78.0878 99.2887 77.8213Z",
    fill: "#D47858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3126 82.6735C98.6921 82.1971 98.6773 81.5534 98.2795 81.2357C97.8817 80.9181 97.2516 81.0469 96.8721 81.5233C96.4926 81.9998 96.5075 82.6435 96.9052 82.9611C97.303 83.2787 97.9331 83.15 98.3126 82.6735Z",
    fill: "#D47858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2431 83.8026C94.6913 83.2978 94.6598 82.537 94.1725 82.1032C93.6853 81.6694 92.9269 81.727 92.4787 82.2317C92.0304 82.7365 92.062 83.4973 92.5492 83.9311C93.0364 84.3648 93.7948 84.3073 94.2431 83.8026Z",
    fill: "#D47858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M131.128 48C141.937 47.9761 148.757 65.5796 146.065 76.7367C143.684 86.6162 136.843 88.6625 131.366 88.6625C125.89 88.6625 119.24 86.0047 116.668 77.1193C113.693 66.8299 121.042 48.0239 131.128 48Z",
    fill: "#ED9449"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.881 56.3766C121.584 58.4502 120.277 61.0602 119.998 63.2362C119.486 67.2434 122.43 67.6943 123.457 65.7061C124.484 63.7179 125.535 61.7058 127.204 59.0378C129.51 55.3518 133.287 52.8819 131.431 51.2797C129.575 49.6775 125.604 52.0176 122.881 56.3766Z",
    fill: "#F2B25C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M140.671 62.0507C141.052 62.0507 141.36 61.7357 141.36 61.347C141.36 60.9584 141.052 60.6433 140.671 60.6433C140.29 60.6433 139.982 60.9584 139.982 61.347C139.982 61.7357 140.29 62.0507 140.671 62.0507Z",
    fill: "#D47858"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M141.446 78.8741C141.603 78.4919 141.422 78.0553 141.042 77.8989C140.662 77.7424 140.227 77.9254 140.07 78.3075C139.913 78.6896 140.094 79.1262 140.474 79.2827C140.854 79.4391 141.289 79.2562 141.446 78.8741Z",
    fill: "#D47858"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M121.357 81.8685C121.503 81.5125 121.334 81.1053 120.978 80.9589C120.623 80.8125 120.216 80.9823 120.07 81.3383C119.923 81.6942 120.093 82.1015 120.449 82.2479C120.804 82.3943 121.211 82.2244 121.357 81.8685Z",
    fill: "#D47858"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M143.228 68.6514C143.741 68.3849 143.968 67.8022 143.734 67.3499C143.5 66.8976 142.894 66.747 142.38 67.0135C141.866 67.28 141.64 67.8627 141.874 68.315C142.108 68.7673 142.714 68.9179 143.228 68.6514Z",
    fill: "#D47858"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M133.289 77.8213C133.802 77.5548 134.029 76.9721 133.795 76.5198C133.561 76.0675 132.955 75.9169 132.441 76.1834C131.927 76.4499 131.701 77.0326 131.935 77.4848C132.169 77.9371 132.775 78.0878 133.289 77.8213Z",
    fill: "#D47858"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M132.313 82.6735C132.692 82.1971 132.677 81.5534 132.28 81.2357C131.882 80.9181 131.252 81.0469 130.872 81.5233C130.493 81.9998 130.507 82.6435 130.905 82.9611C131.303 83.2787 131.933 83.15 132.313 82.6735Z",
    fill: "#D47858"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M128.243 83.8026C128.691 83.2978 128.66 82.537 128.173 82.1032C127.685 81.6694 126.927 81.727 126.479 82.2317C126.03 82.7365 126.062 83.4973 126.549 83.9311C127.036 84.3648 127.795 84.3073 128.243 83.8026Z",
    fill: "#D47858"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 75.635C42.0003 75.6814 42.0003 75.728 41.9995 75.774C41.9032 75.9348 41.8039 76.0929 41.7039 76.2493C39.038 80.3923 35.0765 83.0185 30.6535 83.0185C22.6265 83.0185 16.1191 74.3688 16.1191 63.6981C16.1191 62.1477 16.2566 60.6395 16.5163 59.195C19.1959 56.3857 22.5794 54.7094 26.2575 54.7094C34.9517 54.7086 42.0003 64.0778 42.0003 75.635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4393 96.5619C71.1343 96.5619 78.1829 87.1926 78.1829 75.6351C78.1829 64.0775 71.1343 54.7083 62.4393 54.7083C53.7444 54.7083 46.6958 64.0775 46.6958 75.6351C46.6958 87.1926 53.7444 96.5619 62.4393 96.5619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6215 96.5619C107.316 96.5619 114.365 87.1926 114.365 75.6351C114.365 64.0775 107.316 54.7083 98.6215 54.7083C89.9266 54.7083 82.8779 64.0775 82.8779 75.6351C82.8779 87.1926 89.9266 96.5619 98.6215 96.5619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.942 63.6977C144.942 74.3684 138.435 83.0182 130.408 83.0182C125.985 83.0182 122.023 80.3919 119.357 76.2489C119.257 76.0926 119.158 75.9344 119.062 75.7736C119.061 75.7277 119.061 75.6814 119.061 75.6347C119.061 64.0775 126.11 54.7083 134.804 54.7083C138.483 54.7083 141.866 56.385 144.545 59.1939C144.805 60.6391 144.942 62.1473 144.942 63.6977Z",
    fill: "black"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M149.591 83.1309H13.1185V92.4238H149.591V83.1309Z",
    fill: "#AA9D93"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M40.396 59.3608L43.1215 60.2989V82.981H33.1377L40.396 59.3608Z",
    fill: "#E0C7AC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8471 59.3608L43.1215 60.2989V82.981H53.1054L45.8471 59.3608Z",
    fill: "#CBB39E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3958 59.3609L43.1214 58.3058L45.8469 59.3609L43.1214 60.2989L40.3958 59.3609Z",
    fill: "#FFEAD7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8994 59.3608L80.6249 60.2989V82.981H70.6411L77.8994 59.3608Z",
    fill: "#E0C7AC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3504 59.3608L80.6249 60.2989V82.981H90.6087L83.3504 59.3608Z",
    fill: "#CBB39E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8992 59.3609L80.6248 58.3058L83.3504 59.3609L80.6248 60.2989L77.8992 59.3609Z",
    fill: "#FFEAD7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 59.3608L118.128 60.2989V82.981H108.145L115.403 59.3608Z",
    fill: "#E0C7AC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M120.854 59.3608L118.128 60.2989V82.981H128.112L120.854 59.3608Z",
    fill: "#CBB39E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 59.3609L118.129 58.3058L120.854 59.3609L118.129 60.2989L115.403 59.3609Z",
    fill: "#FFEAD7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1276 59C34.9367 58.9761 41.7572 76.5796 39.0652 87.7367C36.6836 97.6162 29.8427 99.6625 24.3665 99.6625C18.8903 99.6625 12.2404 97.0047 9.66775 88.1193C6.69252 77.8299 14.0419 59.0239 24.1276 59Z",
    fill: "#F2A05B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8808 67.3766C14.5843 69.4502 13.2775 72.0602 12.9977 74.2362C12.4859 78.2434 15.4304 78.6943 16.4574 76.7061C17.4844 74.7179 18.5353 72.7058 20.2038 70.0378C22.5103 66.3518 26.2873 63.8819 24.4312 62.2797C22.5751 60.6775 18.6036 63.0176 15.8808 67.3766Z",
    fill: "#FECC88"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6709 73.0507C34.0515 73.0507 34.3601 72.7357 34.3601 72.347C34.3601 71.9584 34.0515 71.6433 33.6709 71.6433C33.2903 71.6433 32.9817 71.9584 32.9817 72.347C32.9817 72.7357 33.2903 73.0507 33.6709 73.0507Z",
    fill: "#D47858"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4459 89.8741C34.6029 89.4919 34.4222 89.0553 34.0423 88.8989C33.6623 88.7424 33.2271 88.9254 33.0701 89.3075C32.9131 89.6896 33.0939 90.1262 33.4738 90.2827C33.8537 90.4391 34.2889 90.2562 34.4459 89.8741Z",
    fill: "#D47858"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3571 92.8685C14.5034 92.5125 14.3337 92.1053 13.9782 91.9589C13.6227 91.8125 13.2159 91.9823 13.0697 92.3383C12.9235 92.6942 13.0931 93.1015 13.4486 93.2479C13.8042 93.3943 14.2109 93.2244 14.3571 92.8685Z",
    fill: "#D47858"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2277 79.6514C36.7413 79.3849 36.9679 78.8022 36.7338 78.3499C36.4998 77.8976 35.8936 77.747 35.38 78.0135C34.8663 78.28 34.6397 78.8627 34.8738 79.315C35.1079 79.7673 35.714 79.9179 36.2277 79.6514Z",
    fill: "#D47858"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2887 88.8213C26.8023 88.5548 27.029 87.9721 26.7949 87.5198C26.5608 87.0675 25.9546 86.9169 25.441 87.1834C24.9274 87.4499 24.7008 88.0326 24.9348 88.4848C25.1689 88.9371 25.7751 89.0878 26.2887 88.8213Z",
    fill: "#D47858"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3126 93.6735C25.6921 93.1971 25.6773 92.5534 25.2795 92.2357C24.8817 91.9181 24.2516 92.0469 23.8721 92.5233C23.4926 92.9998 23.5075 93.6435 23.9052 93.9611C24.303 94.2787 24.9331 94.15 25.3126 93.6735Z",
    fill: "#D47858"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2431 94.8026C21.6913 94.2978 21.6598 93.537 21.1725 93.1032C20.6853 92.6694 19.9269 92.727 19.4787 93.2317C19.0304 93.7365 19.062 94.4973 19.5492 94.9311C20.0364 95.3648 20.7948 95.3073 21.2431 94.8026Z",
    fill: "#D47858"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1276 59C72.9367 58.9761 79.7572 76.5796 77.0652 87.7367C74.6836 97.6162 67.8427 99.6625 62.3665 99.6625C56.8903 99.6625 50.2404 97.0047 47.6677 88.1193C44.6925 77.8299 52.0419 59.0239 62.1276 59Z",
    fill: "#F2A05B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8808 67.3766C52.5843 69.4502 51.2775 72.0602 50.9977 74.2362C50.4859 78.2434 53.4304 78.6943 54.4574 76.7061C55.4844 74.7179 56.5353 72.7058 58.2038 70.0378C60.5103 66.3518 64.2873 63.8819 62.4312 62.2797C60.5751 60.6775 56.6036 63.0176 53.8808 67.3766Z",
    fill: "#FECC88"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6709 73.0507C72.0515 73.0507 72.3601 72.7357 72.3601 72.347C72.3601 71.9584 72.0515 71.6433 71.6709 71.6433C71.2903 71.6433 70.9817 71.9584 70.9817 72.347C70.9817 72.7357 71.2903 73.0507 71.6709 73.0507Z",
    fill: "#D47858"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4459 89.8741C72.6029 89.4919 72.4222 89.0553 72.0423 88.8989C71.6623 88.7424 71.2271 88.9254 71.0701 89.3075C70.9131 89.6896 71.0939 90.1262 71.4738 90.2827C71.8537 90.4391 72.2889 90.2562 72.4459 89.8741Z",
    fill: "#D47858"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3571 92.8685C52.5034 92.5125 52.3337 92.1053 51.9782 91.9589C51.6227 91.8125 51.2159 91.9823 51.0697 92.3383C50.9235 92.6942 51.0931 93.1015 51.4486 93.2479C51.8042 93.3943 52.2109 93.2244 52.3571 92.8685Z",
    fill: "#D47858"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2277 79.6514C74.7413 79.3849 74.9679 78.8022 74.7338 78.3499C74.4998 77.8976 73.8936 77.747 73.38 78.0135C72.8663 78.28 72.6397 78.8627 72.8738 79.315C73.1079 79.7673 73.714 79.9179 74.2277 79.6514Z",
    fill: "#D47858"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2887 88.8213C64.8023 88.5548 65.029 87.9721 64.7949 87.5198C64.5608 87.0675 63.9546 86.9169 63.441 87.1834C62.9274 87.4499 62.7008 88.0326 62.9348 88.4848C63.1689 88.9371 63.7751 89.0878 64.2887 88.8213Z",
    fill: "#D47858"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3126 93.6735C63.6921 93.1971 63.6773 92.5534 63.2795 92.2357C62.8817 91.9181 62.2516 92.0469 61.8721 92.5233C61.4926 92.9998 61.5075 93.6435 61.9052 93.9611C62.303 94.2787 62.9331 94.15 63.3126 93.6735Z",
    fill: "#D47858"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2431 94.8026C59.6913 94.2978 59.6598 93.537 59.1725 93.1032C58.6853 92.6694 57.9269 92.727 57.4787 93.2317C57.0304 93.7365 57.062 94.4973 57.5492 94.9311C58.0364 95.3648 58.7948 95.3073 59.2431 94.8026Z",
    fill: "#D47858"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1276 59C109.937 58.9761 116.757 76.5796 114.065 87.7367C111.684 97.6162 104.843 99.6625 99.3665 99.6625C93.8903 99.6625 87.2404 97.0047 84.6677 88.1193C81.6925 77.8299 89.0419 59.0239 99.1276 59Z",
    fill: "#F2A05B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8808 67.3766C89.5843 69.4502 88.2775 72.0602 87.9977 74.2362C87.4859 78.2434 90.4304 78.6943 91.4574 76.7061C92.4844 74.7179 93.5353 72.7058 95.2038 70.0378C97.5103 66.3518 101.287 63.8819 99.4312 62.2797C97.5751 60.6775 93.6036 63.0176 90.8808 67.3766Z",
    fill: "#FECC88"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M108.671 73.0507C109.052 73.0507 109.36 72.7357 109.36 72.347C109.36 71.9584 109.052 71.6433 108.671 71.6433C108.29 71.6433 107.982 71.9584 107.982 72.347C107.982 72.7357 108.29 73.0507 108.671 73.0507Z",
    fill: "#D47858"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M109.446 89.8741C109.603 89.4919 109.422 89.0553 109.042 88.8989C108.662 88.7424 108.227 88.9254 108.07 89.3075C107.913 89.6896 108.094 90.1262 108.474 90.2827C108.854 90.4391 109.289 90.2562 109.446 89.8741Z",
    fill: "#D47858"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3571 92.8685C89.5034 92.5125 89.3337 92.1053 88.9782 91.9589C88.6227 91.8125 88.2159 91.9823 88.0697 92.3383C87.9235 92.6942 88.0931 93.1015 88.4486 93.2479C88.8042 93.3943 89.2109 93.2244 89.3571 92.8685Z",
    fill: "#D47858"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M111.228 79.6514C111.741 79.3849 111.968 78.8022 111.734 78.3499C111.5 77.8976 110.894 77.747 110.38 78.0135C109.866 78.28 109.64 78.8627 109.874 79.315C110.108 79.7673 110.714 79.9179 111.228 79.6514Z",
    fill: "#D47858"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M101.289 88.8213C101.802 88.5548 102.029 87.9721 101.795 87.5198C101.561 87.0675 100.955 86.9169 100.441 87.1834C99.9274 87.4499 99.7008 88.0326 99.9348 88.4848C100.169 88.9371 100.775 89.0878 101.289 88.8213Z",
    fill: "#D47858"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M100.313 93.6735C100.692 93.1971 100.677 92.5534 100.28 92.2357C99.8817 91.9181 99.2516 92.0469 98.8721 92.5233C98.4926 92.9998 98.5075 93.6435 98.9052 93.9611C99.303 94.2787 99.9331 94.15 100.313 93.6735Z",
    fill: "#D47858"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2431 94.8026C96.6913 94.2978 96.6598 93.537 96.1725 93.1032C95.6853 92.6694 94.9269 92.727 94.4787 93.2317C94.0304 93.7365 94.062 94.4973 94.5492 94.9311C95.0364 95.3648 95.7948 95.3073 96.2431 94.8026Z",
    fill: "#D47858"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M136.128 59C146.937 58.9761 153.757 76.5796 151.065 87.7367C148.684 97.6162 141.843 99.6625 136.366 99.6625C130.89 99.6625 124.24 97.0047 121.668 88.1193C118.693 77.8299 126.042 59.0239 136.128 59Z",
    fill: "#F2A05B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M127.881 67.3766C126.584 69.4502 125.277 72.0602 124.998 74.2362C124.486 78.2434 127.43 78.6943 128.457 76.7061C129.484 74.7179 130.535 72.7058 132.204 70.0378C134.51 66.3518 138.287 63.8819 136.431 62.2797C134.575 60.6775 130.604 63.0176 127.881 67.3766Z",
    fill: "#FECC88"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M145.671 73.0507C146.052 73.0507 146.36 72.7357 146.36 72.347C146.36 71.9584 146.052 71.6433 145.671 71.6433C145.29 71.6433 144.982 71.9584 144.982 72.347C144.982 72.7357 145.29 73.0507 145.671 73.0507Z",
    fill: "#D47858"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M146.446 89.8741C146.603 89.4919 146.422 89.0553 146.042 88.8989C145.662 88.7424 145.227 88.9254 145.07 89.3075C144.913 89.6896 145.094 90.1262 145.474 90.2827C145.854 90.4391 146.289 90.2562 146.446 89.8741Z",
    fill: "#D47858"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M126.357 92.8685C126.503 92.5125 126.334 92.1053 125.978 91.9589C125.623 91.8125 125.216 91.9823 125.07 92.3383C124.923 92.6942 125.093 93.1015 125.449 93.2479C125.804 93.3943 126.211 93.2244 126.357 92.8685Z",
    fill: "#D47858"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M148.228 79.6514C148.741 79.3849 148.968 78.8022 148.734 78.3499C148.5 77.8976 147.894 77.747 147.38 78.0135C146.866 78.28 146.64 78.8627 146.874 79.315C147.108 79.7673 147.714 79.9179 148.228 79.6514Z",
    fill: "#D47858"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M138.289 88.8213C138.802 88.5548 139.029 87.9721 138.795 87.5198C138.561 87.0675 137.955 86.9169 137.441 87.1834C136.927 87.4499 136.701 88.0326 136.935 88.4848C137.169 88.9371 137.775 89.0878 138.289 88.8213Z",
    fill: "#D47858"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M137.313 93.6735C137.692 93.1971 137.677 92.5534 137.28 92.2357C136.882 91.9181 136.252 92.0469 135.872 92.5233C135.493 92.9998 135.507 93.6435 135.905 93.9611C136.303 94.2787 136.933 94.15 137.313 93.6735Z",
    fill: "#D47858"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M133.243 94.8026C133.691 94.2978 133.66 93.537 133.173 93.1032C132.685 92.6694 131.927 92.727 131.479 93.2317C131.03 93.7365 131.062 94.4973 131.549 94.9311C132.036 95.3648 132.795 95.3073 133.243 94.8026Z",
    fill: "#D47858"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02637 82.9812C6.05156 96.9958 13.7562 108.346 23.257 108.346C32.7577 108.346 40.4624 96.9958 40.4876 82.9812H6.02637Z",
    fill: "url(#paint2_radial_10258_11878)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M14 104V110.387C14 111.278 18.0294 112 23 112C27.9706 112 32 111.278 32 110.387V104H14Z",
    fill: "url(#paint3_linear_10258_11878)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2715 82.9812C44.2967 96.9958 52.0014 108.346 61.5021 108.346C71.0028 108.346 78.7075 96.9958 78.7327 82.9812H44.2715Z",
    fill: "url(#paint4_radial_10258_11878)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104V110.387C52 111.278 56.2533 112 61.5 112C66.7467 112 71 111.278 71 110.387V104H52Z",
    fill: "url(#paint5_linear_10258_11878)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5171 82.9812C82.5423 96.9958 90.247 108.346 99.7477 108.346C109.248 108.346 116.953 96.9958 116.978 82.9812H82.5171Z",
    fill: "url(#paint6_radial_10258_11878)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104V110.387C91 111.278 95.0294 112 100 112C104.971 112 109 111.278 109 110.387V104H91Z",
    fill: "url(#paint7_linear_10258_11878)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M120.762 82.9812C120.787 96.9958 128.492 108.346 137.993 108.346C147.494 108.346 155.198 96.9958 155.223 82.9812H120.762Z",
    fill: "url(#paint8_radial_10258_11878)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M129 104V110.387C129 111.278 133.029 112 138 112C142.971 112 147 111.278 147 110.387V104H129Z",
    fill: "url(#paint9_linear_10258_11878)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M40.488 82.9812H6.02637C6.0297 84.7617 6.15714 86.4988 6.39647 88.1756H40.1182C40.3572 86.4988 40.4846 84.7617 40.488 82.9812Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M78.7331 82.9812H44.2715C44.2748 84.7617 44.4023 86.4988 44.6416 88.1756H78.3634C78.6023 86.4988 78.7301 84.7617 78.7331 82.9812Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M116.979 82.9812H82.5171C82.5204 84.7617 82.6479 86.4988 82.8872 88.1756H116.609C116.848 86.4988 116.975 84.7617 116.979 82.9812Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M155.224 82.9812H120.762C120.766 84.7617 120.893 86.4988 121.132 88.1756H154.854C155.093 86.4988 155.22 84.7617 155.224 82.9812Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0.738892 81.5089V82.2469C0.738892 83.4654 1.72657 84.4531 2.94505 84.4531H158.305C159.524 84.4531 160.511 83.4654 160.511 82.2469V81.5089H0.738892Z",
    fill: "#F4E7D9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0083 72.8969C33.071 72.8969 29.8738 76.4386 29.8245 80.8287H44.1925C44.1429 76.4386 40.9457 72.8969 37.0083 72.8969Z",
    fill: "#FCEBDB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0083 73.5745C33.0709 73.5745 29.8737 77.1162 29.8245 81.5063H44.1924C44.1428 77.1162 40.9456 73.5745 37.0083 73.5745Z",
    fill: "url(#paint10_linear_10258_11878)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M29.9104 80.3612C29.8582 80.735 29.8285 81.1173 29.8245 81.5063H44.1924C44.188 81.1173 44.1584 80.735 44.1065 80.3612H29.9104Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M124.241 72.8969C120.304 72.8969 117.107 76.4386 117.058 80.8287H131.426C131.376 76.4386 128.179 72.8969 124.241 72.8969Z",
    fill: "#FCEBDB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M124.242 73.5746C120.304 73.5746 117.107 77.1163 117.058 81.5064H131.426C131.376 77.1163 128.179 73.5746 124.242 73.5746Z",
    fill: "url(#paint11_linear_10258_11878)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M117.144 80.3612C117.091 80.735 117.062 81.1174 117.058 81.5064H131.426C131.421 81.1174 131.392 80.735 131.34 80.3612H117.144Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10258_11878",
    x1: 80.0374,
    y1: 0.454641,
    x2: 80.0374,
    y2: 75.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D5C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10258_11878",
    x1: 80.0377,
    y1: 2.9007,
    x2: 80.0377,
    y2: 66.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10258_11878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2572 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10258_11878",
    x1: 13.9998,
    y1: 108,
    x2: 31.9998,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10258_11878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.5024 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10258_11878",
    x1: 52,
    y1: 108,
    x2: 70.9999,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_10258_11878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.7478 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10258_11878",
    x1: 91.0001,
    y1: 108,
    x2: 109,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10258_11878",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.993 95.6632) scale(15.1284 15.1284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10258_11878",
    x1: 129,
    y1: 108,
    x2: 147,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#E7D5C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3C0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10258_11878",
    x1: 37.0083,
    y1: 73.6295,
    x2: 37.0083,
    y2: 81.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10258_11878",
    x1: 124.242,
    y1: 73.6296,
    x2: 124.242,
    y2: 81.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6D6C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggBoxFull);
export default __webpack_public_path__ + "static/media/egg_box_full.824fc6a19ad8495de003417d8068f4bc.svg";
export { ForwardRef as ReactComponent };